import { render } from "./BlogPostDetailsCard.vue?vue&type=template&id=70b11894"
import script from "./BlogPostDetailsCard.vue?vue&type=script&lang=js"
export * from "./BlogPostDetailsCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__